module.exports = __webpack_public_path__ + "static/pic08-a41cbb64f1df3c8236947494b0ea7a50.jpg";